const Newsletter = {

    loading: false,
    init: () => {
        Newsletter.initNewsletterForm();
    },

    initNewsletterForm: () => {

        const forms = document.querySelectorAll(`[data-newsletter-form]`);
        forms.forEach((form) => {
            const button = form.querySelector('[type="submit"]');

            form.addEventListener('submit', (ev) => {
                ev.preventDefault();

                if (Newsletter.loading) {
                    return false;
                }

                Newsletter.loading = true;

                const data = new FormData();
                data.append('email', form.querySelector('[name="user_email"]').value);
                data.append('group', form.querySelector('[name="group"]').value);
                data.append('nonce', ajax_var.ajax_nonce);
                data.append('action', 'register_newsletter_subscriber');

                form.classList.toggle('loading', Newsletter.loading);
                button?.classList.toggle('button-loading', Newsletter.loading);

                const responseMessage = form.querySelector('[data-newsletter-response]');
                responseMessage.classList.remove('visible', 'error');

                fetch(form.action, {
                    method: 'post',
                    body: data,
                }).then((response) => {
                    return response.json();
                }).then((response) => {
                    if (response.success) {
                        responseMessage.innerText = responseMessage.getAttribute('data-newsletter-response');
                        return;
                    }
                    responseMessage.classList.add('error');
                    responseMessage.innerText = responseMessage.getAttribute('data-newsletter-response-error');

                }).catch((reason) => {
                    console.warn(reason);
                    responseMessage.classList.add('error');
                    responseMessage.innerText = responseMessage.getAttribute('data-newsletter-response-error');
                }).finally(() => {
                    Newsletter.loading = false;
                    form.classList.toggle('loading', Newsletter.loading);
                    button?.classList.toggle('button-loading', Newsletter.loading);
                    responseMessage.classList.add('visible');
                    form.reset();
                })

                return false;
            })
        })
    }


}
export default Newsletter;
